<script setup>
import { useAppState } from '../stores/app-state';

const appState = useAppState();

const props = defineProps(["Component", "route"]);

</script>

<template>
  <Transition mode="out-in" :name="route.meta.transition || 'fade'">
    <component :is="Component" />
  </Transition>
</template>

<style lang="scss" scoped>
.updating {
  position: fixed;
  bottom: var(--inside-padding-horiz);
  right: var(--inside-padding-horiz);
  width: auto;
  height: auto;
  padding: 20px;
  background: #fff;
  z-index: 9999;
  display: flex;
  align-items: center;
  box-shadow: rgb(100 100 111 / 20%) 0px 7px 29px 0px;

  .loading {
    width: 32px;
    min-width: 32px;
    margin-right: var(--grid-gap);
  }
}
</style>